<template>
  <div :class="menuClass + ' custom-container'">
    <div v-if="loader" class="loading-layout">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else class="profil page-wrapp">
      <v-row class="justify-center">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <v-row class="align-center">
            <v-col v-on:click="goToLink('#/profil')" cols="1">
              <v-btn elevation="2" icon
                ><v-icon>mdi-chevron-left</v-icon></v-btn
              >
            </v-col>
            <v-col cols="11">
              <v-card-title>Endre passord</v-card-title>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="justify-center mb-5">
        <v-col
          :cols="!$vuetify.breakpoint.smAndDown ? 7 : 12"
          :class="
            !$vuetify.breakpoint.smAndDown ? 'justify-content-center' : ''
          "
        >
          <div class="reset-password">
            <v-row>
              <v-col
                :class="
                  !$vuetify.breakpoint.smAndDown ? 'text-left' : 'text-justify'
                "
              >
                <span class="text--secondary"
                  >Passordet må være mellom 8 og 16 tegn, og inkludere en stor
                  bokstav, Ett tall eller symbol.</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mb-0 pb-0">
                <v-text-field
                  v-model="newPassword"
                  label="Passord"
                  outlined
                  class="rounded-lg"
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordFormatRules"
                  :type="showPassword ? 'text' : 'password'"
                  @click:append="showPassword = !showPassword"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-left mb-5 custom-list">
                <ul>
                  <li>
                    <span class="text--secondary pl-2"
                      >Mellom 8 og 16 tegn</span
                    >
                  </li>
                  <li>
                    <span class="text--secondary pl-2">En stor bokstav</span>
                  </li>
                  <li>
                    <span class="text--secondary pl-2"
                      >Ett tall eller symbol</span
                    >
                  </li>
                </ul>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mb-0 pb-0">
                <v-text-field
                  v-model="newPasswordConfirm"
                  label="Bekreft passord"
                  outlined
                  class="rounded-lg"
                  :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="passwordMatchRules"
                  :type="showPasswordConfirm ? 'text' : 'password'"
                  @click:append="showPasswordConfirm = !showPasswordConfirm"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-left custom-list">
                <ul>
                  <li>
                    <span class="text--secondary pl-2"
                      >Passord må samsvare.</span
                    >
                  </li>
                </ul>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-btn
                  rounded
                  color="primary"
                  class="font-weight-bold"
                  v-on:click="save"
                >
                  Endre Passord
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-snackbar v-model="snackbar">
        {{ snackbarText }}

        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" v-on:click="snackbar = false">
            Lukke
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { editPassword } from "@/api/common";

import "./Profil.scss";

export default {
  name: "Profil",

  components: {},

  data() {
    return {
      loader: false,
      menuClass: "",
      newPassword: "",
      newPasswordConfirm: "",
      snackbar: false,
      snackbarText: "",
      passwordFormatRules: [
        (value) =>
          /^(?=.*?[A-Z])(?=.*?[0-9]|.*?[#?!@$%^&*-]).{8,16}$/.test(value) ||
          "Ugyldig passord",
      ],
      passwordMatchRules: [
        (value) => value == this.newPassword || "Passordene er ikke like",
      ],
      showPassword: false,
      showPasswordConfirm: false,
    };
  },

  beforeMount() {
    this.loader = true;
    // this.service = new window.google.maps.places.PlacesService(document.createElement('div'))
  },

  mounted() {
    this.loader = false;

    if (localStorage.tenant === "9876543210517") {
      this.menuClass = "sokrates";
    } else if (localStorage.tenant === "7080010002488") {
      this.menuClass = "klark";
    } else {
      this.menuClass = "hks";
    }
  },

  methods: {
    goToLink(route) {
      let tmp = document.createElement("a");
      tmp.href = route;
      tmp.click();
    },

    validatePassword() {
      for (let i = 0; i < this.passwordFormatRules.length; i++) {
        let result = this.passwordFormatRules[i](this.newPassword);
        if (result && result !== true) return result;
      }

      for (let i = 0; i < this.passwordMatchRules.length; i++) {
        let result = this.passwordMatchRules[i](this.newPasswordConfirm);
        if (result && result !== true) return result;
      }

      return "";
    },

    async save() {
      let validationErrors = this.validatePassword();

      if (!validationErrors) {
        try {
          this.loader = true;
          await editPassword(JSON.stringify({ Password: this.newPassword }));

          this.snackbar = true;
          this.snackbarText = "Passordet ble oppdatert";
        } catch (e) {
          this.snackbar = true;
          this.snackbarText = "Feil passord oppdater";
        }

        this.loader = false;
      } else {
        this.snackbar = true;
        this.snackbarText = "Ugyldig data";
      }
    },
  },
};
</script>

<style>
ul {
  list-style: none;
}

li::before {
  content: "• ";
  color: rgba(0, 0, 0, 0.6) !important;
}
</style>